import { render, staticRenderFns } from "./AcceptTermsForm.vue?vue&type=template&id=4ebe2df6&scoped=true"
import script from "./AcceptTermsForm.vue?vue&type=script&lang=js"
export * from "./AcceptTermsForm.vue?vue&type=script&lang=js"
import style0 from "./AcceptTermsForm.vue?vue&type=style&index=0&id=4ebe2df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe2df6",
  null
  
)

export default component.exports